import * as React from 'react';
import { DataGrid, itIT } from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Grid from '@mui/material/Grid';
import { GridToolbarContainer } from '@mui/x-data-grid'; 
import Typography from '@mui/material/Typography';
import CustomGridLoadingOverlay from './custom-grid-loading-overlay-component';
import AddCompetitionAdminDialog from './add-competition-admin-dialog-component';
import ConfirmDialog from './confirm-dialog-component'
import Switch from '@mui/material/Switch';
import UserService from "../services/user-service";

function ActionsButton(props) {
  const { deleteAction, editAction, switchAction } = props;
  
  return (
  	<Grid container direction="row" alignItems="center">
  		<Switch
		  checked={props.enabled}
		  onChange={switchAction}
		  inputProps={{ 'aria-label': 'controlled' }}
		/>
	    <IconButton onClick={deleteAction}><DeleteIcon /></IconButton>
	</Grid>
  );
}

 function CustomToolbar(props) {
  const { addAction } = props;
  return (
    <GridToolbarContainer>
      	<Grid container justifyContent="flex-end">
	      <Button variant="contained" endIcon={<AddIcon />} onClick={addAction}>
	        Aggiungi
	      </Button>
	  	</Grid>
    </GridToolbarContainer>
  );
}

export default class AdminsGrid extends React.Component {
  	constructor(props) {
	    super(props);
	    this.state = {
	      open: false,
	      openConfirm: false,
	      openEdit: false,
	      adminToDelete: ''
	    };
  	}
  
  handleClickOpenConfirm = () => {
    this.setState({openConfirm: true})
  };

  handleCloseConfirm = () => {
    this.setState({openConfirm: false})
  };
  
  handleConfirmAction = () => {
    this.setState({openConfirm: false})
  };

  handleConfirmAction = async e => {
    e.preventDefault();
    UserService.deleteUser({email: this.state.adminToDelete.email}).then(
      response => {
        this.handleCloseConfirm();
		this.props.refreshAdmins();
      },
      error => {
        this.handleCloseConfirm();
		this.props.refreshAdmins();
      }
    );
  } 
  
  handleClickOpen = () => {
    this.setState({open: true})
  };

  handleClose = () => {
    this.setState({open: false})
  };

  handleCloseEdit = () => {
    this.setState({openEdit: false})
  };

	switchAction = (adminToSwitch) => {
		adminToSwitch.enabled = !adminToSwitch.enabled
	   	UserService.updateStatusAssociation(adminToSwitch).then(
	      response => {
			this.props.refreshAdmins();
	      },
	      error => {
			this.props.refreshAdmins();
	      }
	    );
	}
  
  columns = [
  	{
	    field: 'email',
	    headerName: 'Email',
	    width: 600 
	  },
	  {
	    field: 'actions',
	    headerName: 'Azioni',
	    width: 200,
	    editable: false,
	    renderCell: (params) => {
	      
	      	const deleteAction = (e) => {
		        e.stopPropagation();
		        this.setState({
		        	openConfirm :true,
		        	adminToDelete: params.row
		        })
	      	};

	      	const switchAction = (e) => {
		        e.stopPropagation();
		        this.switchAction(params.row)
		        
	      	};
	
	      	return <ActionsButton enabled={params.row.enabled} deleteAction={deleteAction} switchAction={switchAction}/>;
	    }
	  },
	];
  
  render(){
	  return (
	    <div style={{ height: 350, width: '100%' }}>
	      <Typography variant="h4" gutterBottom component="div" >
	      	 Amministratori Gara
	      </Typography>
	      <DataGrid
	        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
	        rows={this.props.admins}
	        columns={this.columns}
	        pageSize={5}
	        rowsPerPageOptions={[5]}
	        disableSelectionOnClick
	        loading={this.props.admins.length===0}
	        sx={{ marginBottom:'15px'}}
			components={{
	          Toolbar: CustomToolbar,
	          LoadingOverlay: CustomGridLoadingOverlay,
	        }}
	        componentsProps={{
	          toolbar: {addAction:this.handleClickOpen}
	        }}
	      />
	      <AddCompetitionAdminDialog
	      	open={this.state.open}
	        handleClose={this.handleClose}
	        refreshAdmins={this.props.refreshAdmins}
	      />
	      <ConfirmDialog
	      	open={this.state.openConfirm}
	        handleClose={this.handleCloseConfirm}
	        confirmAction={this.handleConfirmAction}
	        title={"Conferma cancellazione"}
	        message={"Sei sicuro di procedere con la cancellazione?"}
	      />
	    </div>
	  );
  }
}